import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import {
    customersSelector,
    dashboardActions,
} from '../../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { CustomerInfo } from '../../../../../types/dashboardInformation';
import { setCustomer } from '../../../../../../../store/slices/dashboardSlice/action';

export interface OptionsList {
    title: string;
    value: number;
}

export const useCustomerRow = () => {
    const dispatch = useDispatch();

    const customers = useSelector(customersSelector.selectAll);
    const customersEntities = useSelector(customersSelector.selectEntities);
    //@ts-ignore
    const { currentCustomerId, is_customer, can_show_financial_info } = useSelector(
        (store) => store.dashboardReducer
    );
    const [optionsList, setOptionsList] = useState([]);
    const [selected, setSelected] = useState({
        title: i18next.t('useCustomerRow.return.defaultSelected'),
        value: null,
    });

    useEffect(() => {
        setOptionsList(
            customers.reduce((acc: OptionsList[], customer: CustomerInfo) => {
                const obj = { title: customer.name, value: customer.id };
                if (customer.selected) {
                    setSelected({ title: customer.name, value: customer.id });
                }
                acc.push(obj);
                return acc;
            }, [])
        );

        if (!selected) {
            setSelected(optionsList[0]);
        }
    }, [customers]);

    useEffect(() => {
        //@ts-ignore
        const foundSelected = customers.find((customer) => customer.selected);

        if (foundSelected) {
            dispatch(dashboardActions.changeCurrentCustomerId(foundSelected.id));
            setSelected({
                title: foundSelected.name,
                value: foundSelected.id,
            });
        } else {
            setSelected({ title: i18next.t('useCustomerRow.return.defaultSelected'), value: null });
        }
    }, [customers]);

    const onSelected = useCallback(
        (value: string) => {
            const selectedOption = optionsList.find((option) => option.value === value);
            if (selectedOption) {
                const selectedCustomer = customersEntities[selectedOption.value];
                dispatch(dashboardActions.updateCustomer({ ...selectedCustomer, selected: true }));
                dispatch(dashboardActions.changeCurrentCustomerId(selectedOption.value));
                dispatch(setCustomer({ guid: selectedCustomer.guid }));
                setSelected(selectedOption);
            }
        },
        [optionsList]
    );

    const onAddCustomer = useCallback(() => {
        dispatch(dashboardActions.onModalMode('addCustomer'));
    }, []);

    const onEditCustomer = useCallback(() => {
        dispatch(dashboardActions.onModalMode('editCustomer'));
    }, []);

    return {
        optionsList,
        selected,
        onSelected,
        onAddCustomer,
        currentCustomerId,
        onEditCustomer,
        is_customer,
        can_show_financial_info,
    };
};
